import React, {useState, useRef, useEffect} from 'react'
import ReactPlayer from 'react-player'
import logo from './logo.svg'
import Call_php_iniziale from './components/caricamento_dati_utente_php_start';
import Lista_video_da_studiare from './components/lista_video_da_studiare';
import Calcolo_tempo_visione from './components/calcolo_tempo_visione';
import Salvataggio_dei_dati from './components/salvataggio_dei_dati';
import Form from './components/form';
import Todo from './components/formtodo';
import Caricamento_dati_utente from './components/caricamento_dati_utente';

import './App.css'

function App() {
  const [todos, setTodos] = useState([])

/*  ([
    {domanda: 'domanda esempio 1', tempo: 1},
    {domanda: 'domanda esempio 2', tempo: 2},
    {domanda: 'domanda esempio 3', tempo: 3},
  ]);
*/  

  const [tempo_corrente, function_set_tempo_corrente] = useState(0);
  const [tempo_durata_video, function_set_tempo_totale] = useState(0);
  const [tempo_seek, function_set_tempo_seek] = useState(0);

  const [playing, setplaying] = useState(false);
  const [pausa, setpausa] = useState(false);
  const [lista_file_video, funzione_set_lista_file] = useState('');
  const [video_scelto, funzione_scelta_video] = useState({indice: 0, url: 'https://www.youtube.com/watch?v=cTCIDd9BIwY'});
  const [vettore_progress, funzione_vettore_progress] = useState('');
  const [aggiornamento, funzione_set_aggiornamento] = useState(false);
  const [utente, funzione_set_lista_utenti] = useState({nome: 'q1', cognome: 'f1', creato: false, 
                                                        video_guardati: [{video_scelto: video_scelto.url, array_visione: [0,0,0,0,0,0,0,0,0,0]}]});

//  video_guardati: [{nome_video: 'video1', array_visione: '[1,0,0,0]'},
//  {nome_video: 'video2', array_visione: '[0,0,1,0]'},
//], }

  const player = useRef(null);
 
 
  useEffect(() => {
    const interval = setInterval(() => 
    {aggiorna_current_player()}, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
     if (lista_file_video !== '') {
     player.current.seekTo(tempo_seek, "seconds")
    }
  }, [tempo_seek]);


  const aggiorna_current_player = () => {
    var tempo
    tempo = (player.current !== null)  ? player.current.getCurrentTime() : 0
    function_set_tempo_corrente (tempo)
    var tempo_totale
    tempo_totale = (player.current !== null)  ? player.current.getDuration() : 0
    function_set_tempo_totale (tempo_totale )
  }


  const nuovo_video_guardato = () => {
//    var size_vettore = 10;
    console.log('AAAAAAA nuovo_video_guardato');
    var utente_new = utente
    var todos_new = todos
//    var vettore =  Array.apply(null, Array(size_vettore)).map(Number.prototype.valueOf,0); 
    var indice_trovato = -1
    var numero_video = utente_new.video_guardati.length 

// cerca se il video e' stato gia' selezionato    
    const sweeterArray = utente_new.video_guardati.map((itemtodo, index) => {
      console.log('app.js - controllo lista video');
      console.log( itemtodo.video_scelto.url);
   
      if (itemtodo.video_scelto == video_scelto) {
            console.log('app.js - esiste' + index + ' - ' + itemtodo)
            indice_trovato = index
      }
    })
  utente_new.indice_video = indice_trovato 
   
  if (indice_trovato == -1) {
    utente_new.video_guardati.push({video_scelto, array_visione: [0,0,0,0,0,0,0,0,0,0]}) 
    todos_new.push({domanda: [1,1,1]})
    utente_new.indice_video = numero_video
  }
    console.log(utente_new)
    funzione_set_lista_utenti(utente_new)
    funzione_vettore_progress(JSON.stringify(utente_new))
    setTodos(todos_new)
  }  
  
//function() {calcolo_tempo_visione()}

//

  return (
    
    <div className="App">
        <div className="out1">
            <div className="out1">

             <Caricamento_dati_utente setTodos = {setTodos} 
                                      funzione_set_lista_utenti = {funzione_set_lista_utenti}              
                                      funzione_set_lista_file={funzione_set_lista_file} 
                                      funzione_scelta_video = {funzione_scelta_video}
                                      lista_file_video = {lista_file_video}   />
            </div>  
            <Calcolo_tempo_visione utente = {utente} 
                    aggiornamento = {aggiornamento}  funzione_set_aggiornamento = {funzione_set_aggiornamento} 
                    player_current = {player.current} 
                    video_scelto = {video_scelto}
                    tempo_corrente = {tempo_corrente} 
                    tempo_durata_video = {tempo_durata_video} 
                  
                    funzione_set_lista_utenti = {funzione_set_lista_utenti} 
                    funzione_vettore_progress = {funzione_vettore_progress} />
            <Salvataggio_dei_dati  aggiornamento = {aggiornamento}  
                                   funzione_set_aggiornamento = {funzione_set_aggiornamento}
                                   funzione_set_lista_utenti = {funzione_set_lista_utenti} 
                                   utente = {utente}
                                   todos = {todos}
                                   />                     

                  
            <div className="out6">
                    <Lista_video_da_studiare lista_file_video = {lista_file_video} 
                                             utente = {utente}
                                             todos = {todos}
                                             video_scelto = {video_scelto}
                                             funzione_scelta_video = {funzione_scelta_video} 
                                             funzione_vettore_progress = {funzione_vettore_progress} />
      
            </div>



         
          <div className="out2">
              
            <div className="player-wrapper">
            <ReactPlayer controls 
                            className="react-player"
                            playing
                            width="100%"
                            height="100%"
                            playing={playing} ref={player} muted={false} url = {video_scelto.url}
      /*                  config={{ file: {
                      tracks: [
                        {kind: 'subtitles', src: './sub/TED.vtt', srcLang: 'en', default: true}
                      ]
                      }}} 
      */
                      onReady ={() => {console.log('onReady')}}
                      onStart ={() => {console.log('onStart');console.log(player.current.getCurrentTime()) }}
                      onPause ={() => {console.log('onpause');console.log(player.current.getCurrentTime()) }} />
            </div>
          </div>

          <div className="out6">
            <div className="out7">
                  
                  <Form setTodos = {setTodos} todos = {todos} 
                                    tempo_corrente = {tempo_corrente} 
                                    tempo_durata_video = {tempo_durata_video} 
                                    video_scelto = {video_scelto}
                                    funzione_set_aggiornamento = {funzione_set_aggiornamento} />        
                  {todos.map((itemtodo,index ) => (
                     <Todo key={index} itemtodo= {itemtodo} index={index} 
                        video_scelto = {video_scelto}
                        todos = {todos} setTodos = {setTodos} 
                        function_set_tempo_seek = {function_set_tempo_seek} />
                  ))}
            </div>
          </div>

        </div>


        {function() {
              if (2 == 1) {
                    console.log('formtodo.js entrato');
                    { 
                    <label p/>
                   }
              }
           }
      }  
          {/*vettore_progress*/}
      
          {/*       setEmail(player.current.getCurrentTime()) */}
            
    </div>
  );
}

export default App;
